import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  & > :first-child {
    display: flex;
    justify-content: space-between;
  }
`;
